"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputBase = function InputBase(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      endAdornment = _ref.endAdornment,
      ref = _ref.forwardRef,
      inputComponent = _ref.inputComponent,
      inputRef = _ref.inputRef,
      inputClassName = _ref.inputClassName,
      placeholder = _ref.placeholder,
      required = _ref.required,
      startAdornment = _ref.startAdornment,
      type = _ref.type,
      value = _ref.value,
      restOfProps = _objectWithoutProperties(_ref, ["className", "disabled", "endAdornment", "forwardRef", "inputComponent", "inputRef", "inputClassName", "placeholder", "required", "startAdornment", "type", "value"]);

  var InputComponent = inputComponent;
  var inputProps = {};
  /**
   * Pass a reference of the input element to the parent when it is not a custom InputComponent
   * Otherwise, the custom InputComponent should pass it to the parent
   */

  if (typeof inputRef === 'function') {
    if (typeof InputComponent === 'string') {
      inputRef(ref);
    } else {
      inputProps.inputRef = inputRef;
    }
  }

  inputProps['aria-required'] = required;
  return _react.default.createElement("div", {
    className: className
  }, startAdornment, _react.default.createElement(InputComponent, _extends({}, restOfProps, inputProps, {
    className: inputClassName,
    disabled: disabled,
    placeholder: placeholder,
    ref: ref,
    required: required,
    type: type,
    value: value
  })), endAdornment);
};

InputBase.propTypes = {
  // "aria-invalid" accepts true/false as a boolean, and grammar/spelling as a string
  // See: https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/125
  'aria-invalid': (0, _propTypes.oneOf)(['grammar', 'spelling', true, false]).isRequired,
  className: _propTypes.string,
  disabled: _propTypes.bool,
  endAdornment: _propTypes.node,
  forwardRef: (0, _propTypes.shape)({
    current: _propTypes.object
  }),
  inputComponent: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.object]),
  inputRef: _propTypes.func,
  inputClassName: _propTypes.string,
  placeholder: _propTypes.string,
  required: _propTypes.bool,
  startAdornment: _propTypes.node,
  type: _propTypes.string,
  value: _propTypes.string
};
InputBase.defaultProps = {
  className: null,
  disabled: false,
  endAdornment: null,
  forwardRef: {},
  inputComponent: 'input',
  inputRef: null,
  inputClassName: null,
  placeholder: '',
  required: false,
  startAdornment: null,
  type: 'text',
  // Undefined for input to be uncontrolled
  value: undefined
};

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement(InputBase, _extends({}, props, {
    forwardRef: ref
  }));
});

exports.default = _default;
